// @owners { team: patients }
import { getDeliveryItemsForShipment } from '~shared/features/delivery-info/selectors/getDeliveryItems';
import getShipments from '~shared/features/shipments/selectors/getShipments';
import { useOrderPricing } from '~shared/queries';
import { useSelectorShared } from '~shared/store';
import { useShipmentID } from '../../../index';

export const useShipment = () => {
  const { shipmentID } = useShipmentID();
  const shipments = useSelectorShared(getShipments);
  const { orderPricing } = useOrderPricing({ shipmentID: shipmentID || undefined });
  const shipment = shipments.find(({ id }) => id === shipmentID);
  const shipmentItems = useSelectorShared((state) => getDeliveryItemsForShipment(state, { shipmentID, orderPricing }));

  return {
    shipment,
    shipmentID,
    shipmentItems,
  };
};
